module.exports = __webpack_public_path__ + "static/media/product-team.e77fc8dd.svg";